import { StepperStep } from '@/shared/types/stepper';

interface StepLabelProps {
  step: StepperStep;
  stepIndex: number;
  className?: string;
  vertical?: boolean;
  white?: boolean;
}

/**
 * StepLabel - Textos del paso (título y descripción)
 * Usa tokens semánticos para tipografía y colores
 */
export const StepLabel = ({
  step,
  stepIndex,
  className = '',
  vertical = false,
  white = false,
}: StepLabelProps) => {
  if (!step.title) return null;

  const titleColor = white ? 'ui-text-white' : 'ui-text-tertiary';
  const descriptionColor = white ? 'ui-text-white' : 'ui-text-primary';

  return (
    <div className={`${!vertical ? 'ui-mt-2 ui-text-center' : ''} ui-w-full ${className}`}>
      <div className={titleColor}>
        <p className="ui-line-clamp-1 ui-break-words ui-text-body-xs-regular ui-font-body-xs-regular ui-leading-body-xs-regular ui-tracking-body-xs">
          {step.title || `Paso ${stepIndex + 1}`}
        </p>
      </div>
      {step.description && (
        <div
          className={`ui-mt-1 ui-text-body-sm-bold ui-font-body-sm-bold ui-leading-body-sm-bold ui-tracking-body-sm ${descriptionColor}`}
        >
          <p className="ui-line-clamp-1 ui-whitespace-normal ui-break-words">{step.description}</p>
        </div>
      )}
    </div>
  );
};
